import { authReturnTo } from './authNavigation';

/** Unknown or absent preferences are legacy accounts, not new onboarding. */
export function normalizePreferredExperience(value) {
  if (typeof value !== 'string') return null;
  const preference = value.trim().toLowerCase();
  return ['chat', 'remote', 'later'].includes(preference) ? preference : null;
}

/** Safe navigation-only projection; never retain other account/draft fields. */
export function normalizeOnboarding(value) {
  return {
    preferred_experience: normalizePreferredExperience(value?.preferred_experience),
    onboarding_completed: value?.onboarding_completed === true,
  };
}

/** CRA build-time rollout flag: absent, truthy strings and casing variants are off. */
export function isExperienceOnboardingEnabled() {
  return process.env.REACT_APP_EXPERIENCE_ONBOARDING_ENABLED === 'true';
}

/** Pure destination mapping; callers handling rollout should use postAuthDestination. */
export function defaultOnboardingDestination(record) {
  const { preferred_experience: preference, onboarding_completed: completed } = normalizeOnboarding(record);
  if (preference === 'remote') return completed ? '/agent' : '/onboarding/cli';
  if (preference === 'later' && !completed) return '/onboarding';
  return '/chat';
}

/** Explicit returns always win, including a deliberate /activate return. */
export function postAuthDestination(location, record, { enabled = isExperienceOnboardingEnabled() } = {}) {
  return authReturnTo(location, null)
    || (enabled === true ? defaultOnboardingDestination(record) : '/chat');
}

// Integration names; original exports remain available to existing callers.
export const normalizeOnboardingPreferences = normalizeOnboarding;
export const onboardingDestination = defaultOnboardingDestination;
export const postLoginDestination = postAuthDestination;
